import Vue from 'vue'
import { Button, Form, Field,Popup,Icon,Sidebar,SidebarItem, Dialog,
    Tag, Pagination, Picker, DatetimePicker,Calendar,  Toast, Loading ,Cell ,CellGroup ,Checkbox,CheckboxGroup, Divider, Popover} from 'vant';
import 'vant/lib/button/style';
import 'vant/lib/form/style';
import 'vant/lib/field/style';
import 'vant/lib/popup/style';
import 'vant/lib/icon/style';
import 'vant/lib/sidebar/style';
import 'vant/lib/sidebar-item/style';
import 'vant/lib/dialog/style';
import 'vant/lib/tag/style';
import 'vant/lib/pagination/style';
import 'vant/lib/picker/style';
import 'vant/lib/datetime-picker/style';
import 'vant/lib/calendar/style';
import 'vant/lib/list/style';
import 'vant/lib/toast/style';
import 'vant/lib/loading/style';
import 'vant/lib/cell/style';
import 'vant/lib/checkbox/style';
import 'vant/lib/divider/style';
import 'vant/lib/popover/style';

Vue.use(Form);
Vue.use(Field);
Vue.use(Button);
Vue.use(Popup);
Vue.use(Icon);
Vue.use(Sidebar);
Vue.use(SidebarItem);
Vue.use(Tag);
Vue.use(Pagination);
Vue.use(Picker);
Vue.use(DatetimePicker);
Vue.use(Calendar);
Vue.use(Dialog);
Vue.use(Toast);
Vue.use(Loading);
Vue.use(Cell);
Vue.use(CellGroup);
Vue.use(Checkbox);
Vue.use(CheckboxGroup);
Vue.use(Divider);
Vue.use(Popover);
